import { BuisnessPromotion } from 'src/app/models/common';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { Component, NgZone, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddAdminPostComponent } from 'src/app/shared/components/add-admin-post/add-admin-post.component';
import { NavigationService } from '../../../../providers/navigation.service';
import { ActivatedRoute } from '@angular/router';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';

@Component({
  selector: 'sm-public-posts',
  templateUrl: './public-posts.component.html',
  styleUrls: ['./public-posts.component.scss']
})
export class PublicPostsComponent implements OnInit, OnDestroy {
  private _apiSubscription: Subscription = new Subscription();
  public adminPostList: BuisnessPromotion[] = [];
  public modelSubscription: Subscription = new Subscription();
  public page: number = 1;
  public isLoading: boolean = false;
  constructor(
    private _modelRef: MatDialog,
    private _apiService: ApiService,
    private _ngZone: NgZone,
    private _navService: NavigationService,
    private route: ActivatedRoute,
    private loaderservice: LoaderServiceService
  ) {
    this._navService.hideSidebarAndNav = false;
  }
  public totalData: number = 0;
  accountHash:any
  publicPostsData:any = []
  ngOnInit(): void {
    this.isLoading = true;
    this.loaderservice.showLoader = true
    this.route.queryParams.subscribe(data => {
      console.log(data.entityHash);
      this.accountHash = data.accountHash
      this._apiService.getPostsAsPerID(this.accountHash)
      
    })
    // this.modelSubscription = this._modelRef.afterAllClosed.subscribe((data) => {
    //   this.isLoading = true;
    //   this._apiService.getAdminPostInfoList(this.page.toString());
    // });
    this._apiSubscription = this._apiService.apiResult.subscribe((response) => {
      console.log(response);
      if (response.responseType === SM_CONSTANTS.RESULT_API_GET_POSTS_AS_PER_ID) {
        if (response.result) {
          this.publicPostsData = []
          this.publicPostsData = response.result;

          this.isLoading = false
          this.loaderservice.showLoader = false
        }
      }
      
    });
  }

  openModel(event: any) {
    this._modelRef.open(AddAdminPostComponent, {
      minWidth: '400px',
      data: {
        title: 'Edit business post',
        type: SM_CONSTANTS.BUISNESS_PROMOTION,
        ref: this._modelRef,
        data: event,
      },
    });
  }

  ngOnDestroy() {
    this._apiSubscription.unsubscribe();
    this.modelSubscription.unsubscribe();
  }

  onPageChange(ev: any) {
    this.isLoading = true;
    console.log(ev?.pageIndex + 1);
    this.page = ev?.pageIndex + 1;
    this._apiService.getAdminPostInfoList(this.page.toString());
  }

  onCreateNewPost() {
    this._modelRef.open(AddAdminPostComponent, {
      minWidth: '400px',
      data: {
        title: 'Add admin post',
        type: SM_CONSTANTS.ADMIN_POST,
        ref: this._modelRef,
      },
    });
  }
}

